var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event item"},[(_vm.isList)?_c('com-row',{attrs:{"event":_vm.event}}):_vm._e(),(_vm.isGrid)?_c('com-card',{attrs:{"loading":_vm.loading,"event":_vm.event}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }